module.exports = __webpack_public_path__ + "static/media/申万宏源APP.ad02b6a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/申万宏源APP.mp4
// module id = m7Xi
// module chunks = 3